// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"155":"dc72a0a7","179":"811a93c4","396":"f745f7e7","656":"220da389","793":"bc4a3dd0","921":"b2889174","979":"d373b9e5"}[chunkId] + ".chunk.js";
};